// Port of api/fuel/app/classes/filter/search/games/filters/query/game/included.php
export default {
	name: 'game.included',
	priority: 80,
	require: function(config, filter) {
		return filter.games && filter.games.whitelist && filter.games.whitelist.length > 0
	},
	run: function(config, filter, data, query) {
		query.whitelist('g.game_id', 'in', filter.games.whitelist)
	}
}
